import { render, staticRenderFns } from "./JourneyDetailModal.vue?vue&type=template&id=1ad9f230&"
import script from "./JourneyDetailModal.vue?vue&type=script&lang=js&"
export * from "./JourneyDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./JourneyDetailModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports